import { Link } from "react-router-dom";
import ManualFrame from "../../components/manuals/ManualFrame";
import { flattenTree } from "../../manuals/schema";
import { appUrl } from "../../config";

export default function ManualHome({ role, pack }) {
  const start = flattenTree(pack.tree).find((item) => item.slug === "start-here");

  return (
    <ManualFrame role={role} tree={pack.tree} meta={pack.meta}>
      <article className="manual-article">
        <h1>{pack.meta.title}</h1>
        {start ? (
          <>
            <p className="lead">{start.forYou}</p>
            <section>
              <h2>How the Process Works</h2>
              <ol className="manual-steps">
                {start.how.map((step) => (
                  <li key={step}>{step}</li>
                ))}
              </ol>
            </section>
            <section>
              <h2>{pack.meta.whyHeading}</h2>
              <p>{start.why}</p>
            </section>
            {start.examples.map((item) => (
              <p key={item} className="manual-example">
                {item}
              </p>
            ))}
            <p>
              <Link className="btn" to={`/manuals/${role}/start-here`}>
                Open Start Here
              </Link>
            </p>
          </>
        ) : null}
        <p className="manual-hint">
          The topics on the left are the house. Search for a word you actually say. When you want
          the working desk,{" "}
          <a href={appUrl("/")}>open REChecklist</a>.
        </p>
      </article>
    </ManualFrame>
  );
}
